"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.picker.title': 'Seleziona file da Google Drive',
    'googleDrive.picker.selectFile': 'Seleziona file da Google Drive',
    'googleDrive.picker.selectFiles': 'Seleziona file da Google Drive',
    'googleDrive.picker.loading': 'Caricamento API Google Drive...',
    'googleDrive.picker.initializing': 'Inizializzazione selettore file...',
    'googleDrive.picker.notAuthenticated': 'Google Drive non connesso',
    'googleDrive.picker.statusError': 'Errore nel controllo dello stato di Google Drive',
    'googleDrive.picker.filesLoadError': 'Errore nel caricamento dei file',
    'googleDrive.picker.checkingAuth': 'Controllo autenticazione...',
    'googleDrive.picker.authRequired': 'Si prega di collegare prima il proprio account Google Drive',
    'googleDrive.picker.connectAccount': 'Collega Google Drive',
    'googleDrive.picker.loadingFiles': 'Caricamento dei tuoi file Google Drive...',
    'googleDrive.picker.noFiles': 'Nessun file trovato',
    'googleDrive.picker.noFilesDesc': 'Il tuo Google Drive sembra essere vuoto',
    'googleDrive.picker.refresh': 'Aggiorna',
    'googleDrive.picker.searchPlaceholder': 'Cerca file...',
    'googleDrive.picker.filesFound': 'file trovati',
    'googleDrive.picker.initError': 'Impossibile inizializzare il selettore di Google Drive',
    'googleDrive.picker.loadingError': 'Impossibile caricare le API di Google Drive',
    'googleDrive.picker.noAccessToken': 'Token di accesso non disponibile',
    'googleDrive.picker.error': 'Errore del selettore di Google Drive',
    'googleDrive.picker.fileSelected': 'File selezionato',
    'googleDrive.picker.filesSelected': 'file selezionati',
    'googleDrive.picker.authError': 'Autenticazione Google fallita',
    'googleDrive.picker.configError': 'Errore di configurazione Google',
    'googleDrive.picker.selectDirectory': 'Seleziona directory di Google Drive',
    'googleDrive.picker.createError': 'Errore nell\'apertura del selettore di Google Drive',
    'googleDrive.picker.connectFirst': 'Per favore, connetti prima Google Drive nelle tue impostazioni',
    'googleDrive.picker.tokenExpired': 'L\'accesso a Google Drive è scaduto. Per favore, riconnetti il tuo account Google Drive nelle impostazioni.',
    'googleDrive.picker.refreshFailed': 'Errore nell\'aggiornamento dell\'accesso a Google Drive. Per favore, riconnetti il tuo account nelle impostazioni.',
};
